export class Para {
  private _adres1: string;
  private _adres2: string;  
  private _open: boolean = false;
  
  constructor(data: any = null) {
    if (data) {
      this.normalize(data);
    }
  }  

  public normalize(data: any = null) {
    this.adres1 = data[0];
    this.adres2 = data[1];
  }

  get open(): boolean {
    return this._open;
  }

  set open(value: boolean) {
    this._open = value;
  }

  get adres1(): string {
    return this._adres1;
  }

  set adres1(value: string) {
    this._adres1 = value;
  }

  get adres2(): string {
    return this._adres2;
  }

  set adres2(value: string) {
    this._adres2 = value;
  }
}
